import React, {useEffect} from "react";
import {graphql} from "gatsby";
import {Asset} from "../../../../plugins/gatsby-plugin-atollon";
import { gsap } from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const ImageBanner = ({image, video}) => {

    useEffect(() => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: `.image-banner__inner`,
            start: 'top top',
            end: 'bottom top',
            scrub: true,
          },
        });
    
        tl.fromTo(
          `.image-banner__inner .image-banner__wrapper`,
          { yPercent: 0 },
          { yPercent: 35, ease: 'none' }
        );
    
        return () => {
          tl.kill();
        };
      }, []);

    return (
        <section className='image-banner'>
            <div className='image-banner__inner'>
                <div className="image-banner__wrapper">
                    {image && !video && <Asset asset={image}/>}
                    {video && <video className='title-gallery__video' src={video} autoPlay loop muted playsInline/>}
                </div>
            </div>
        </section>
    )
}

export default ImageBanner

export const query = graphql`
fragment ImageBannerProps on DatoCmsImageBanner {
  ... on DatoCmsImageBanner {
    id
    video
    image {
      ...InternalAssetProps
    }
  }
}
`